/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface OverrideJustificationArtefact
 */
export interface OverrideJustificationArtefact {
  /**
   *
   * @type {number}
   * @memberof OverrideJustificationArtefact
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof OverrideJustificationArtefact
   */
  justification: number;
  /**
   *
   * @type {string}
   * @memberof OverrideJustificationArtefact
   */
  file?: string | null;
}

/**
 * Check if a given object implements the OverrideJustificationArtefact interface.
 */
export function instanceOfOverrideJustificationArtefact(value: object): value is OverrideJustificationArtefact {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('justification' in value) || value['justification'] === undefined) return false;
  return true;
}

export function OverrideJustificationArtefactFromJSON(json: any): OverrideJustificationArtefact {
  return OverrideJustificationArtefactFromJSONTyped(json, false);
}

export function OverrideJustificationArtefactFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OverrideJustificationArtefact {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    justification: json['justification'],
    file: json['file'] == null ? undefined : json['file'],
  };
}

export function OverrideJustificationArtefactToJSON(value?: Omit<OverrideJustificationArtefact, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    justification: value['justification'],
    file: value['file'],
  };
}
